import React from 'react'
import Link from 'gatsby-link'

const Nav = () => (
  <nav>
    <a href={`${process.env.DEMO_ENDPOINT}`}>Demo</a>
    <Link to="/#pricing">Pricing</Link>
    <a href={`${process.env.APP_URL}/signup`}>Sign up</a>
    <a href={`${process.env.APP_URL}`}>App →</a>
  </nav>
)

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/index.js